import { useState } from "react";
import { Upload, CheckCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { api } from "../lib/api";

export default function DobUpload() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleFileUpload = async () => {
    if (!file) return;
    setLoading(true);
    setMessage("");

    const reader = new FileReader();
    reader.onload = async (e) => {
      const text = e.target.result;
      // Simple CSV parser
      const rows = text.split("\n").map(r => r.split(","));
      
      // Map to the format the backend expects
      const payload = rows.slice(1) // Skip header row
        .filter(row => row[0] && row[1]) // Filter empty rows
        .map(row => ({
          roll_no: row[0].trim(),
          dob: row[1].trim() // Format should be YYYY-MM-DD to match the HTML date picker
        }));

      try {
        const res = await api.post("/admin/students/dob", payload);
        setMessage(`Successfully updated ${res.data.updated} student records!`);
        setFile(null);
      } catch (err) {
        setMessage("Error uploading DOBs. Check format.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    reader.readAsText(file);
  };

  return (
    <div className="max-w-3xl mx-auto space-y-6 fade-up">
      <div>
        <h1 className="text-3xl font-display text-stone-900">Upload Date of Births</h1>
        <p className="text-stone-500 mt-1">Upload a CSV file to grant students access to their results.</p>
      </div>

      <Card className="p-8 bg-white border-stone-200 shadow-sm rounded-sm text-center">
        <div className="max-w-md mx-auto">
          <p className="text-sm text-stone-600 mb-6 text-left bg-stone-50 p-4 border border-stone-200">
            <strong>Required CSV Format:</strong><br/>
            Row 1 must be headers: <code>roll_no, dob</code><br/>
            Dates MUST be in <strong>YYYY-MM-DD</strong> format.<br/>
            <em>Example: 250090703001, 2004-05-14</em>
          </p>

          <input
            type="file"
            accept=".csv"
            onChange={(e) => setFile(e.target.files[0])}
            className="block w-full text-sm text-stone-500 file:mr-4 file:py-2 file:px-4 file:rounded-sm file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-900 hover:file:bg-indigo-100 mb-4"
          />
          
          <Button 
            onClick={handleFileUpload} 
            disabled={!file || loading} 
            className="w-full rounded-sm"
          >
            <Upload className="w-4 h-4 mr-2" /> 
            {loading ? "Processing..." : "Upload DOBs"}
          </Button>

          {message && (
            <div className="mt-4 p-3 bg-emerald-50 text-emerald-700 flex items-center justify-center gap-2 rounded-sm text-sm">
              <CheckCircle className="w-4 h-4" /> {message}
            </div>
          )}
        </div>
      </Card>
    </div>
  );
}
